/* ============================================================
   product-kit.js — Sacred Gaia Kit Builder
   Fases 1 & 2: selector, variantes AJAX, precio, carrito
============================================================ */
(function () {
  'use strict';

  /* ── Global Trigger for Modal ──────────────────────────── */
  window.openKitQuiz = function(kitId) {
      window.sgKitQuizMode = kitId;
      if (typeof updateQuizForKit === 'function') updateQuizForKit();
      if (typeof openQuiz === 'function') openQuiz();
  };

  var instances = {};

  function initKit(sectionEl) {
    var sid = sectionEl.dataset.kitId || sectionEl.dataset.sectionId;
    if (!sid) return;

    if (instances[sid]) {
        instances[sid].refresh();
        return;
    }

    /* ── Config ─────────────────────────────────────────────── */
    var configEl = document.getElementById('tw-kit-config-' + sid);
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    /* ── State ──────────────────────────────────────────────── */
    var state = {
      selectedSlot: null,
      selectedVariantId: null,
      selectedVariantTitle: null,
      kitPrice: null,
      comparePrice: null,
      discountCode: null,
      savingsText: null,
      personalization: null,
      fixedVariants: {} // Stores { slot: variantId } for variable fixed products
    };

    /* ── DOM refs ───────────────────────────────────────────── */
    var priceEl      = sectionEl.querySelector('.tw-kit__price-value');
    var compareEl    = sectionEl.querySelector('.tw-kit__price-compare');
    var atcBtn       = sectionEl.querySelector('.tw-kit__atc');
    var varGrid      = sectionEl.querySelector('.tw-kit__var-grid');
    var variantWrap  = sectionEl.querySelector('.tw-kit__variant-wrap');
    var variantInner = sectionEl.querySelector('.tw-kit__variant-inner');
    var stepVariant  = sectionEl.querySelector('.tw-kit__step--variant');
    var savingsEl    = sectionEl.querySelector('.tw-kit__savings');
    var fixedGrid    = sectionEl.querySelector('.tw-kit__fixed-list');

    /* ── Personalization Check ──────────────────────────────── */
    function checkPersonalization() {
      var saved = localStorage.getItem('sg-kit-personalization-' + sid);
      if (saved) {
        try {
          state.personalization = JSON.parse(saved);
          sectionEl.querySelectorAll('.tw-kit__quiz-controls').forEach(function(ctrl) {
            var info = ctrl.querySelector('.tw-kit__formula-info');
            var val = ctrl.querySelector('.tw-kit__formula-val');
            var btn = ctrl.querySelector('.tw-kit__quiz-btn');
            
            if (info && val) {
              val.textContent = state.personalization.formula;
              info.hidden = false;
              if (btn) {
                btn.innerText = '✦ Fórmula Lista (Editar)';
                btn.classList.add('tw-kit__quiz-btn--done');
              }
            }
          });
        } catch(e) { console.error('Error parsing personalization', e); }
      } else {
          state.personalization = null;
          sectionEl.querySelectorAll('.tw-kit__quiz-controls').forEach(function(ctrl) {
            var info = ctrl.querySelector('.tw-kit__formula-info');
            var btn = ctrl.querySelector('.tw-kit__quiz-btn');
            if (info) info.hidden = true;
            if (btn) {
                btn.innerText = '✦ Personalizar';
                btn.classList.remove('tw-kit__quiz-btn--done');
            }
          });
      }
      refreshAtc();
    }

    /* ── Format money ───────────────────────────────────────── */
    function money(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents * 100);
      }
      return (cfg.currencySymbol || 'S/. ') + parseFloat(cents).toFixed(2);
    }

    /* ── Update price display ───────────────────────────────── */
    function updatePrice() {
      if (cfg.useBasePriceOnly) {
        if (priceEl) priceEl.textContent = money(cfg.baseDisplayPrice);
        if (compareEl && cfg.baseComparePrice > 0) {
          compareEl.textContent = money(cfg.baseComparePrice);
          compareEl.hidden = false;
        } else if (compareEl) {
          compareEl.hidden = true;
        }
        if (savingsEl) {
          if (cfg.baseSavingsText) {
            savingsEl.textContent = cfg.baseSavingsText;
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }
        return;
      }

      var hasVars = cfg.variableProducts && cfg.variableProducts.length > 0;
      if (state.kitPrice === null) {
        if (!hasVars && cfg.baseDisplayPrice) {
          if (priceEl) priceEl.textContent = money(cfg.baseDisplayPrice);
          if (compareEl && cfg.baseComparePrice > 0) {
            compareEl.textContent = money(cfg.baseComparePrice);
            compareEl.hidden = false;
          } else if (compareEl) {
            compareEl.hidden = true;
          }
        } else {
          if (priceEl) priceEl.textContent = '—';
          if (compareEl) compareEl.hidden = true;
        }
        if (savingsEl) {
          if (cfg.baseSavingsText) {
            savingsEl.textContent = cfg.baseSavingsText;
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }
        return;
      }
      if (priceEl) priceEl.textContent = money(state.kitPrice);
      if (compareEl) {
        if (state.comparePrice && state.comparePrice > 0) {
          compareEl.textContent = money(state.comparePrice);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (savingsEl) {
        if (state.savingsText) {
          savingsEl.textContent = state.savingsText;
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    /* ── Enable/disable ATC ─────────────────────────────────── */
    function refreshAtc() {
      if (!atcBtn) return;
      var ready = false;
      var hasVars = cfg.variableProducts && cfg.variableProducts.length > 0;
      if (!hasVars) {
        ready = true; 
      } else {
        ready = state.selectedSlot !== null && state.selectedVariantId !== null;
      }

      var needsQuiz = false;
      cfg.fixedProducts.forEach(function(fp) {
        if (fp.isQuiz && !state.personalization) needsQuiz = true;
      });
      if (state.selectedSlot !== null) {
        var currentSlot = cfg.variableProducts.find(v => v.slot === state.selectedSlot);
        if (currentSlot && currentSlot.isQuiz && !state.personalization) needsQuiz = true;
      }

      if (needsQuiz) ready = false;

      atcBtn.disabled = !ready;
      atcBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    /* ── Render variants after selectable ───────────────────── */
    function renderVariants(prices, shopifyVariants, noVariants) {
      if (!variantInner) return;
      variantInner.innerHTML = '';

      // Case: No variants (direct selection) or empty manual prices
      if ((noVariants || prices.length === 0) && shopifyVariants.length > 0) {
          var defaultV = shopifyVariants.find(function(v) { return v.available; }) || shopifyVariants[0];
          state.selectedVariantId = defaultV.id;
          state.selectedVariantTitle = defaultV.title;
          
          if (prices.length > 0) {
              state.kitPrice = prices[0].kitPrice;
              state.comparePrice = prices[0].comparePrice;
              state.discountCode = prices[0].discountCode;
              state.savingsText = prices[0].savingsText;
          } else {
              state.kitPrice = defaultV.price / 100;
              state.comparePrice = (defaultV.compare_at_price || 0) / 100;
          }
          updatePrice();
          refreshAtc();
          if (noVariants && stepVariant) stepVariant.hidden = true;
          if (noVariants) return;
      }

      prices.forEach(function (sv) {
        var shopifyV = shopifyVariants.find(function (v) { 
          return v.title.toLowerCase().trim() === sv.name.toLowerCase().trim(); 
        });
        if (!shopifyV) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tw-kit__var-pill';
        if (!shopifyV.available) btn.classList.add('tw-kit__var-pill--unavailable');

        var titleSpan = document.createElement('span');
        titleSpan.textContent = sv.name;
        btn.appendChild(titleSpan);

        if (sv.kitPrice !== null && sv.kitPrice > 0) {
          var priceSpan = document.createElement('span');
          priceSpan.className = 'tw-kit__var-pill-price';
          priceSpan.textContent = money(sv.kitPrice);
          btn.appendChild(priceSpan);
        }

        btn.addEventListener('click', function () {
          if (!shopifyV.available) return; // Prevenir selección si no hay stock

          variantInner.querySelectorAll('.tw-kit__var-pill').forEach(function (p) {
            p.classList.remove('tw-kit__var-pill--selected');
          });
          btn.classList.add('tw-kit__var-pill--selected');
          state.selectedVariantId = shopifyV.id;
          state.selectedVariantTitle = shopifyV.title;
          state.kitPrice = sv.kitPrice;
          state.comparePrice = sv.comparePrice;
          state.discountCode = sv.discountCode;
          state.savingsText = sv.savingsText;
          updatePrice();
          refreshAtc();
        });

        variantInner.appendChild(btn);
      });

      // Auto-select if only one variant and not already handled by noVariants
      if (prices.length === 1 && !state.selectedVariantId) {
          var firstPill = variantInner.querySelector('.tw-kit__var-pill');
          if (firstPill) firstPill.click();
          if (stepVariant) stepVariant.hidden = true;
      } else if (prices.length > 1) {
          if (stepVariant) stepVariant.hidden = false;
      }
      
      if (variantWrap && variantInner.children.length > 0) variantWrap.hidden = false;
    }

    /* ── Load variants via AJAX ─────────────────────────────── */
    function loadVariants(handle, variantPrices, noVariants) {
      if (variantInner) variantInner.innerHTML = '<span class="tw-kit__loading">Cargando opciones…</span>';
      if (variantWrap) variantWrap.hidden = false;

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          renderVariants(variantPrices, prod.variants, noVariants);
        })
        .catch(function () {
          if (variantInner) variantInner.innerHTML = '<span class="tw-kit__error">Error al cargar opciones.</span>';
        });
    }

    /* ── Select variable product card ───────────────────────── */
    function selectCard(cardEl, slotData) {
      varGrid.querySelectorAll('.tw-kit__var-card').forEach(function (c) {
        c.classList.remove('tw-kit__var-card--selected');
      });
      cardEl.classList.add('tw-kit__var-card--selected');

      state.selectedSlot = slotData.slot;
      state.selectedVariantId = null;
      state.selectedVariantTitle = null;
      state.kitPrice = null;
      state.comparePrice = null;
      state.discountCode = null;
      state.savingsText = null;
      updatePrice();
      refreshAtc();

      if (slotData.isQuiz) {
        window.openKitQuiz(sid);
      }

      loadVariants(slotData.handle, slotData.variantPrices || [], slotData.noVariants);
    }

    /* ── Render Fixed Products ──────────────────────────────── */
    function renderFixedProducts() {
        if (!fixedGrid) return;
        fixedGrid.innerHTML = '';
        state.fixedVariants = {}; // Clear previous selections to avoid duplicates/stale data
        cfg.fixedProducts.forEach(function (fp) {
          var item = document.createElement('div');
          item.className = 'tw-kit__fixed-item';

          var imgWrap = document.createElement('div');
          imgWrap.className = 'tw-kit__fixed-img';
          if (fp.image) {
            var img = document.createElement('img');
            img.src = fp.image;
            img.alt = fp.title;
            imgWrap.appendChild(img);
          }
          item.appendChild(imgWrap);

          var textWrap = document.createElement('div');
          textWrap.className = 'tw-kit__fixed-text';
          
          var nameEl = document.createElement('span');
          nameEl.className = 'tw-kit__fixed-name';
          nameEl.textContent = fp.title;
          textWrap.appendChild(nameEl);

          if (fp.qty > 1) {
            var qtyEl = document.createElement('span');
            qtyEl.className = 'tw-kit__fixed-qty';
            qtyEl.textContent = '× ' + fp.qty;
            textWrap.appendChild(qtyEl);
          }

          if (fp.isQuiz) {
            var quizControls = document.createElement('div');
            quizControls.className = 'tw-kit__quiz-controls';
            
            var info = document.createElement('p');
            info.className = 'tw-kit__formula-info';
            info.hidden = true;
            info.innerHTML = 'Fórmula: <span class="tw-kit__formula-val"></span>';
            quizControls.appendChild(info);

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'tw-kit__quiz-btn';
            btn.textContent = '✦ Personalizar';
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                window.openKitQuiz(sid);
            });
            quizControls.appendChild(btn);
            textWrap.appendChild(quizControls);
          }

          var isVariable = fp.isVariable || (fp.variantList && fp.variantList.includes(','));

          if (isVariable) {
            var varSelector = document.createElement('div');
            varSelector.className = 'tw-kit__fixed-var-selector';
            
            fetch('/products/' + fp.handle + '.js')
              .then(r => r.json())
              .then(prod => {
                var allowedVariants = [];
                if (fp.variantList && fp.variantList.includes(',')) {
                    allowedVariants = fp.variantList.split(',').map(s => s.trim().toLowerCase());
                } else if (fp.variantList) {
                    allowedVariants = [fp.variantList.trim().toLowerCase()];
                }

                prod.variants.forEach(v => {
                  if (!v.available) return;
                  
                  // Filter by list if provided
                  if (allowedVariants.length > 0) {
                      var match = allowedVariants.includes(v.title.toLowerCase().trim());
                      if (!match) return;
                  }

                  var pill = document.createElement('button');
                  pill.type = 'button';
                  pill.className = 'tw-kit__fixed-pill';
                  pill.textContent = v.title;
                  if (v.id === fp.variantId) {
                      pill.classList.add('tw-kit__fixed-pill--selected');
                      state.fixedVariants[fp.slot] = v.id;
                  }
                  pill.addEventListener('click', () => {
                    varSelector.querySelectorAll('.tw-kit__fixed-pill').forEach(p => p.classList.remove('tw-kit__fixed-pill--selected'));
                    pill.classList.add('tw-kit__fixed-pill--selected');
                    state.fixedVariants[fp.slot] = v.id;
                  });
                  varSelector.appendChild(pill);
                });
              });
            textWrap.appendChild(varSelector);
          } else {
              state.fixedVariants[fp.slot] = fp.variantId;
          }

          item.appendChild(textWrap);
          fixedGrid.appendChild(item);
        });
    }

    /* ── Build product cards ────────────────────────────────── */
    function renderVariableProducts() {
        if (!varGrid) return;
        varGrid.innerHTML = '';
        cfg.variableProducts.forEach(function (vp) {
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'tw-kit__var-card';

          var imgWrap = document.createElement('div');
          imgWrap.className = 'tw-kit__var-img';
          if (vp.image) {
            var img = document.createElement('img');
            img.src = vp.image;
            img.alt = vp.title;
            imgWrap.appendChild(img);
          }

          var nameEl = document.createElement('span');
          nameEl.className = 'tw-kit__var-name';
          nameEl.textContent = vp.title;

          card.appendChild(imgWrap);
          card.appendChild(nameEl);

          if (vp.isQuiz) {
            var quizBadge = document.createElement('span');
            quizBadge.className = 'tw-kit__quiz-badge';
            quizBadge.textContent = '✦ Personalizado';
            card.appendChild(quizBadge);
          }

          card.addEventListener('click', function () { selectCard(card, vp); });
          varGrid.appendChild(card);
        });
    }

    /* ── Add to cart ────────────────────────────────────────── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        atcBtn.disabled = true;
        var originalText = atcBtn.textContent;
        atcBtn.textContent = 'Agregando…';

        var items = [];
        cfg.fixedProducts.forEach(function (fp) {
          console.log('Sacred Gaia - Debug Fixed Product:', fp);
          if (!fp.displayOnly) {
            var vid = state.fixedVariants[fp.slot] || fp.variantId;
            var item = { id: vid, quantity: fp.qty || 1, properties: {}, _title: fp.title, _slot: fp.slot || fp.slot_id };
            if (fp.isQuiz && state.personalization) {
                item.properties['Fórmula'] = state.personalization.formula;
                item.properties['Tipo'] = state.personalization.type;
            }
            items.push(item);
          }
        });

        if (state.selectedVariantId) {
          var props = { '_kit': cfg.kitTitle || 'Kit', '_producto_elegido': state.selectedVariantTitle || '' };
          var currentSlot = cfg.variableProducts.find(v => v.slot === state.selectedSlot);
          if (currentSlot && currentSlot.isQuiz && state.personalization) {
            props['Fórmula'] = state.personalization.formula;
            props['Tipo'] = state.personalization.type;
          }
          items.push({ id: state.selectedVariantId, quantity: 1, properties: props, _title: state.selectedVariantTitle });
        }

        console.log('Sacred Gaia ATC Items:', items);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function(errBody) { throw errBody; });
          }
          return r.json();
        })
        .then(function () {
          localStorage.removeItem('sg-kit-personalization-' + sid);
          var checkoutUrl = '/checkout';
          var discount = state.discountCode || cfg.baseDiscountCode;
          if (discount) {
            checkoutUrl = '/checkout?discount=' + encodeURIComponent(discount);
          }
          window.location.href = checkoutUrl;
        })
        .catch(function (err) {
          console.error('ATC Error:', err);
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
          
          var errMsg = 'Error al agregar al carrito. Inténtalo de nuevo.';
          if (err && err.description) {
            errMsg = err.description;
          } else if (err && err.message) {
            errMsg = err.message;
          }
          alert(errMsg);
        });
      });
    }

    /* ── Init ───────────────────────────────────────────────── */
    checkPersonalization();
    renderFixedProducts();
    renderVariableProducts();
    updatePrice();
    refreshAtc();

    // Export instance
    instances[sid] = {
        refresh: function() {
            checkPersonalization();
            updatePrice();
        }
    };
  }

  function boot() {
    document.querySelectorAll('.tw-kit-builder[data-kit-id], .tw-kit-builder[data-section-id]').forEach(initKit);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.tw-kit-builder');
    if (el) initKit(el);
  });

  window.addEventListener('sg:kit:personalization:done', function() {
    // Refresh all instances
    for (var k in instances) {
        instances[k].refresh();
    }
  });
})();
